import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { AmbientGlow, Button, Heading } from "../shared";

/**
 * Gradient-background call-to-action banner with decorative glow overlays.
 *
 * @returns {import("react").ReactElement}
 */
export function CtaBanner() {
  return (
    <section className="px-4 py-8 md:px-6 md:py-12">
      <div className="relative mx-auto max-w-310 overflow-hidden rounded-[28px] bg-[linear-gradient(135deg,var(--color-cobalt)_0%,var(--color-cerulean)_100%)] px-6 py-14 text-center md:rounded-[36px] md:px-12 md:py-20">
        <AmbientGlow color="azure" position="top-[-80px] left-[-40px]" size="md" />
        <AmbientGlow color="coral" position="bottom-[-80px] right-[-40px]" size="md" />

        <Heading size="section" className="relative z-10 mx-auto max-w-2xl text-white">
          Ready to Grow?
        </Heading>
        <p className="body-lg relative z-10 mx-auto mt-5 max-w-none px-2 text-white/80 lg:text-[clamp(15px,1.5vw,17px)] lg:whitespace-nowrap">
          Join thousands of brands using DojoMojo to compound subscriber, social, traffic and
          impressions!
        </p>
        <div className="relative z-10 mt-10 inline-flex">
          <Button
            variant="cta"
            href="/app/apply"
            icon={<ArrowForwardIcon fontSize="inherit" sx={{ fontSize: 18 }} />}
          >
            Apply to Join
          </Button>
        </div>
      </div>
    </section>
  );
}
